import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore/client';
import type {
  ZrmClickstreamListing,
  ZrmClickstreamUser,
  ZrmLeaseInfo,
  ZrmListingInfo,
  ZrmUserInfo,
} from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ CLICKSTREAM, COMSCORE });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackSimpleEvent = analytics.createTrackEvent('CLICKSTREAM');

export type UserEventArgs = { user: ZrmClickstreamUser };
export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo>('CLICKSTREAM');

export type ListingUserEventArgs = { currentProperty: ZrmClickstreamListing; user: ZrmClickstreamUser };
export const trackListingUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmListingInfo & ZrmUserInfo>(
  'CLICKSTREAM',
);

export const trackLeaseListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ZrmListingInfo & ZrmLeaseInfo & ZrmUserInfo
>('CLICKSTREAM');
